// Campus photo for /colleges/university-of-tennessee-knoxville: CC BY-SA 4.0, by Bubbahotepblues, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAyres_Hall_at_UT_Knoxville.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-tennessee-knoxville/; credited under the photo.
const photo = {
    "slug": "university-of-tennessee-knoxville",
    "alt": "Ayres Hall and its clock tower on The Hill at the University of Tennessee in Knoxville, Tennessee",
    "src": "/colleges/university-of-tennessee-knoxville/campus-1600.webp",
    "srcSmall": "/colleges/university-of-tennessee-knoxville/campus-800.webp",
    "srcMid": "/colleges/university-of-tennessee-knoxville/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-tennessee-knoxville/og.jpg",
    "title": "Ayres Hall at UT Knoxville",
    "author": "Bubbahotepblues",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAyres_Hall_at_UT_Knoxville.jpg",
    "read": "2026-10-01"
};

export default photo;
